import {useEffect, useRef, useState} from "react";

const RowTRComponentSwitch = ({
    fieldName,
    fieldText = null,
    _TC,
    valueIn,
    hasIn,
    setHasIn = null,
    styleCenterMiddle,
    deactivated = null,
    type = "text",
    inputProps = {},
}) => {
    const [value, setValue] = useState("");
    const [has, setHas] = useState(false);
    const last = useRef(null);

    const changeHas = (e) => {
        setHas(e.target.checked);
        if (!e.target.checked && deactivated) {
            last.current = value;
            setValue(deactivated);
        } else {
            setValue(last.current);
        }
        if (setHasIn) setHasIn(e);
    };
    const changeValue = (e) => {
        setValue(e.target.value);
    };
    if (fieldText === null) {
        fieldText = fieldName;
    }
    useEffect(() => {
        setValue(valueIn);
        setHas(hasIn);
        last.current = valueIn;
    }, [hasIn, valueIn]);

    return (
        <tr>
            <td>{_TC(`${fieldName}.name`)}</td>
            <td>{_TC(`${fieldText}.description`)}</td>
            <td>
                <div className="d-flex justify-content-end align-items-center">
                    <label htmlFor={fieldName} className="form-label me-2 mb-0">
                        {_TC(`${fieldText}.params`)}
                    </label>
                    <input
                        type={type}
                        id={fieldName}
                        name={fieldName}
                        className="form-control text-end"
                        style={{maxWidth: "120px"}}
                        title={_TC(fieldName)}
                        value={value}
                        onChange={changeValue}
                        disabled={!has}
                        {...inputProps}
                    />
                </div>
            </td>
            <td style={styleCenterMiddle}>
                <div className="form-switch">
                    <input
                        type="checkbox"
                        id={`has-${fieldName}`}
                        name={`has-${fieldName}`}
                        className="form-check-input"
                        checked={has}
                        onChange={changeHas}
                    />
                </div>
            </td>
        </tr>
    );
};
export default RowTRComponentSwitch;
